import { ColDef } from 'ag-grid-community';
import { formatPhoneNumber, dateFormatter } from 'src/app/shared/functions';

export const PurchaseOptimizerColumnDef: ColDef[] = [
  {
    // Company ID
    headerName: 'Company ID',
    field: 'company_id',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
    hide: true,
  },
   {
    // Vendor
    headerName: 'Vendor',
    field: 'vendor_name',
    resizable: true,
    width: 105,
    filter: 'agTextColumnFilter',
    cellStyle: (params: any) => {
      if (params.value === 'Out of Stock') {
        return { color: '#dc3545' };
      }
      return { color: '#3b82f6' };
    },
    sort: 'asc',
  },
  {
    // Vendor Cost
    headerName: 'Cost',
    field: 'vendor_cost',
    resizable: true,
    width: 100,
    filter: 'agNumberColumnFilter',
    valueFormatter: (params) => {
      if (params.value == null) return '';
      return '$' + params.value.toFixed(2);
    }
  },
  {
    // Why Selected
    headerName: 'Why Selected',
    field: 'selection_reasons',
    resizable: true,
    width: 200,
    filter: 'agTextColumnFilter',
    valueFormatter: (params) => {
      if (!params.value || !Array.isArray(params.value)) return '';
      return params.value.join(', ');
    },
    cellStyle: (params: any) => {
      const isOos = params.data?.vendor_name === 'Out of Stock';
      return { 
        fontStyle: 'italic', 
        color: isOos ? '#dc3545' : '#94a3b8' 
      };
    }
  },
  {
    // Desired Qty
    headerName: 'Desired Qty',
    field: 'desired_qty',
    resizable: true,
    width: 100,
    filter: 'agTextColumnFilter',
  },
  {
    // Item UPC
    headerName: 'UPC',
    field: 'item_upc',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  {
    // Item Name
    headerName: 'Model Number',
    field: 'item_name',
    resizable: true,
    width: 130,
    filter: 'agTextColumnFilter',
  },
  {
    // Item Description
    headerName: 'Item Description',
    field: 'item_description',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
  },
  {
    //  Added Date
    headerName: 'Added Date',
    field: 'created_date',
    resizable: true,
    width: 120,
    filter: 'agTextColumnFilter',
    valueFormatter: dateFormatter,
  }
];

